export default "__VITE_ASSET__D8T_qO5m__"